import { Divider } from 'antd'
import CustomTag from 'components/CustomTag'
import { EditorContent } from 'components/RichEditor/ContentStyles'
import AlarmIcon from 'components/icons/AlarmIcon'
import CandidatesIcon from 'components/icons/CandidatesIcon'
import PaymentIcon from 'components/icons/PaymentIcon'
import {
  FlexWrap,
  GrayTextSmall,
  SubtitleLarge,
  SubtitleSmall,
  TitleMedium,
} from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/Style/style'
import { toWords } from 'number-to-words'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { formatNumber } from 'utils/formatNumber'

export const VerticalDivider = styled(Divider)`
  height: 40px;
  color: black;
`
const ContentLeft = ({
  jobSection = false,
  tittle,
  jobTypeLevel,
  jobType,
  minCompensation,
  maxCompensation,
  description,
  interviewWorkFlow,
  ctcPeriod,
  internshipStartDate,
  internshipEndDate,
  yearOfExperience,
  employmentType,
  jobDependency,
  candidatesCount,
  publishTo,
}) => {
  const startDate = new Date(internshipStartDate)
  const endDate = new Date(internshipEndDate)

  const formatDate = date => {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const numericToWords = number => {
    if (number) {
      const words = toWords(number)

      return words.charAt(0).toUpperCase() + words.slice(1)
    } else return '-'
  }

  return (
    <>
      {jobSection ? null : (
        <>
          <TitleMedium>{tittle}</TitleMedium>

          <FlexWrap gap="15px" centerVertically>
            <FlexWrap gap="5px" centerVertically>
              <AlarmIcon />
              <SubtitleSmall marginbottom="0" capitalize={true}>
                {checkJobTypeLevel(jobTypeLevel, yearOfExperience)}
                {` (${jobType?.split('_')?.join(' ')?.toLowerCase()})`}
              </SubtitleSmall>
            </FlexWrap>

            <SubtitleSmall marginbottom="0">|</SubtitleSmall>
            <FlexWrap gap="5px" centerVertically>
              <CandidatesIcon />
              <SubtitleSmall marginbottom="0" capitalize={true}>
                {candidatesCount}
              </SubtitleSmall>
            </FlexWrap>

            <SubtitleSmall marginbottom="0">|</SubtitleSmall>

            <FlexWrap gap="5px" centerVertically>
              <PaymentIcon />
              <SubtitleSmall marginbottom="0" color={COLORS.GREY_T_60}>
                {minCompensation === maxCompensation ? (
                  <span>
                    ₹ {formatNumber(Number(minCompensation))}
                    {` (${numericToWords(minCompensation)})`}
                  </span>
                ) : (
                  <span>
                    ₹ {formatNumber(Number(minCompensation))}
                    {`(${numericToWords(minCompensation)})`} - ₹{' '}
                    {formatNumber(Number(maxCompensation))}
                    {`(${numericToWords(maxCompensation)})`}
                  </span>
                )}{' '}
                {!!ctcPeriod && `${ctcPeriod}`}
              </SubtitleSmall>
            </FlexWrap>
          </FlexWrap>
        </>
      )}

      {jobTypeLevel?.includes('INTERN') && (
        <>
          <SubtitleLarge color={COLORS.GREY_T_30}>
            Internship Duration
          </SubtitleLarge>
          <FlexWrap gap="15px" centerVertically>
            <FlexWrap gap="5px" centerVertically>
              <SubtitleSmall marginbottom="0" capitalize={true}>
                Start Date : {formatDate(startDate)}
              </SubtitleSmall>
              <SubtitleSmall marginbottom="0" padding="12px">
                {'     |    '}
              </SubtitleSmall>
              <SubtitleSmall marginbottom="0" capitalize={true}>
                End Date : {formatDate(endDate)}
              </SubtitleSmall>
            </FlexWrap>
          </FlexWrap>
        </>
      )}
      <FlexWrap gap="15px" centerVertically>
        <FlexWrap gap="5px" centerVertically>
          <div>
            <GrayTextSmall>Employment Type</GrayTextSmall>
            <FlexWrap wrap gap="5px">
              <CustomTag message={employmentType} />
            </FlexWrap>
          </div>

          {jobDependency && (
            <>
              <VerticalDivider type="vertical" />

              <div>
                <GrayTextSmall>Hiring Timeline</GrayTextSmall>
                <FlexWrap wrap gap="5px">
                  <CustomTag message={jobDependency} />
                </FlexWrap>
              </div>
            </>
          )}
        </FlexWrap>
      </FlexWrap>

      <SubtitleLarge color={COLORS.GREY_T_30}>Job Description</SubtitleLarge>

      <EditorContent
        dangerouslySetInnerHTML={{
          __html: description || '',
        }}
      />

      <SubtitleLarge color={COLORS.GREY_T_30}>Evaluation Process</SubtitleLarge>

      {interviewWorkFlow?.rounds?.map((item, index) => (
        <div key={index + item?.name}>
          <GrayTextSmall
            capitalize={true}
            marginbottom="10px"
            color={COLORS.GREY_T_30}
          >
            {`Round ${index + 1} - ${item?.name}`}
          </GrayTextSmall>
          <EditorContent
            dangerouslySetInnerHTML={{
              __html: item?.description || '',
            }}
          />
        </div>
      ))}
    </>
  )
}

export default ContentLeft
